import React from 'react'

const TermsAndConditions = () => {
  return (
    <div>
      <div className="bg-gray-300 h-screen">
        <h2 className="text-center pt-8 font-semibold text-black text-4xl">
          This is terms and conditions.
        </h2>
      </div>
    </div>
  )
}

export default TermsAndConditions
